import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Register service worker with auto-reload on update
import { registerSW } from "virtual:pwa-register";

registerSW({
  onNeedRefresh() {
    // New content available — reload automatically
    window.location.reload();
  },
  onOfflineReady() {
    console.log("PWA: offline ready");
  },
});

createRoot(document.getElementById("root")!).render(<App />);
